// extracted by mini-css-extract-plugin
export default {"wrapper":"p5HyKLq_8Zj8kCw2Z6Xf","withoutIcon":"iFt1jD9cQb1_eabCVJ8g","icon":"S89Ubu6_pXxbFZWehf1t","animated":"lAuGx4nhx0QOrwFP8OVB","breathe":"YRt80pys9Ijsqj9cwXFP"};